import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-4',
    products:
      'relative container mt-8 grid grid-cols-2 gap-x-2 gap-y-12 sm:grid-cols-3 md:grid-cols-4 lg:gap-x-10 lg:gap-y-15',
    pagination: 'flex-center container mt-12 flex',
    button: 'mx-auto mt-6 w-fit min-w-[350px] md:mt-8 md:min-w-[400px]'
  }
});
